import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_cycle_cross_billing_report_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_cycle_hdr_guid: fromDatatype.GuidDataFieldInterface;
  employee_code: fromDatatype.VarcharDatatypeInterface;
  employee_name: fromDatatype.VarcharDatatypeInterface;
  company_code: fromDatatype.VarcharDatatypeInterface;
  company_name: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  branch_name: fromDatatype.VarcharDatatypeInterface;
  claim_id: fromDatatype.VarcharDatatypeInterface;
  claim_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_hdr_name: fromDatatype.VarcharDatatypeInterface;
  gl_code: fromDatatype.VarcharDatatypeInterface;
  gl_name: fromDatatype.VarcharDatatypeInterface;
  engagement_entity_name: fromDatatype.VarcharDatatypeInterface;
  billing_branch_guid: fromDatatype.GuidDataFieldInterface;
  billing_branch_name: fromDatatype.VarcharDatatypeInterface;
  claim_amount: fromDatatype.NumericDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_claim_cycle_cross_billing_report_line_RowClass implements bl_aat_claim_cycle_cross_billing_report_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_cycle_hdr_guid: fromDatatype.GuidDataFieldInterface;
  employee_code: fromDatatype.VarcharDatatypeInterface;
  employee_name: fromDatatype.VarcharDatatypeInterface;
  company_code: fromDatatype.VarcharDatatypeInterface;
  company_name: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  branch_name: fromDatatype.VarcharDatatypeInterface;
  claim_id: fromDatatype.VarcharDatatypeInterface;
  claim_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_hdr_name: fromDatatype.VarcharDatatypeInterface;
  gl_code: fromDatatype.VarcharDatatypeInterface;
  gl_name: fromDatatype.VarcharDatatypeInterface;
  engagement_entity_name: fromDatatype.VarcharDatatypeInterface;
  billing_branch_guid: fromDatatype.GuidDataFieldInterface;
  billing_branch_name: fromDatatype.VarcharDatatypeInterface;
  claim_amount: fromDatatype.NumericDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
